export interface Price {
  readonly valueWithTax?: number | undefined;
  readonly valueWithoutTax: number;
}

type PriceToValue<P> = P extends Price ? number : undefined;

type WithValueSuffix<T> = {
  [K in keyof T as `${string & K}Value`]: PriceToValue<T[K]>;
};

const calculatePriceValues = <T extends Record<string, Price | null | undefined>>(
  includeTax: boolean,
  prices: T
): WithValueSuffix<T> => {
  return Object.fromEntries(
    Object.entries(prices).map(([key, price]) => {
      return price == null
        ? [`${key}Value`, undefined]
        : [
            `${key}Value`,
            includeTax ? (price.valueWithTax ?? price.valueWithoutTax) : price.valueWithoutTax
          ];
    })
  ) as WithValueSuffix<T>;
};

export default calculatePriceValues;
